export const OPEN = 'open';
export const CLOSE = 'close';
export const CLOSE_WITH_CHARGE = 'close_with_charge';
